import API from 'services/API';

export default function clearUserData() {
  return API.request({
    method: 'POST',
    url: `/inspector/clear-user-data`,
  });
}
